var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background }),attrs:{"id":"main"}},[_c('AppBar',{on:{"toggleNavigationBar":function($event){_vm.drawer = !_vm.drawer}}}),_c('NavDrawer',{attrs:{"toggle":_vm.drawer},on:{"drawerIsClosed":function($event){_vm.drawer = false}}}),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }